// Enhanced locations for Ghana and Nigeria with more cities and features
export const LOCATIONS = {
  ghana: {
    name: 'Ghana',
    flag: '🇬🇭',
    cities: [
      { name: 'Accra', region: 'Greater Accra', coordinates: { lat: 5.5600, lng: -0.2057 }, population: '2.5M', popular: true },
      { name: 'Kumasi', region: 'Ashanti', coordinates: { lat: 6.6885, lng: -1.6244 }, population: '2.0M', popular: true },
      { name: 'Tamale', region: 'Northern', coordinates: { lat: 9.4035, lng: -0.8423 }, population: '950K', popular: true },
      { name: 'Cape Coast', region: 'Central', coordinates: { lat: 5.1313, lng: -1.2796 }, population: '170K', popular: false },
      { name: 'Sekondi-Takoradi', region: 'Western', coordinates: { lat: 4.9340, lng: -1.7137 }, population: '445K', popular: false },
      { name: 'Sunyani', region: 'Bono', coordinates: { lat: 7.3399, lng: -2.3263 }, population: '87K', popular: false },
      { name: 'Ho', region: 'Volta', coordinates: { lat: 6.6000, lng: 0.4667 }, population: '96K', popular: false },
      { name: 'Koforidua', region: 'Eastern', coordinates: { lat: 6.0944, lng: -0.2591 }, population: '120K', popular: false },
      { name: 'Wa', region: 'Upper West', coordinates: { lat: 10.0600, lng: -2.5000 }, population: '102K', popular: false },
      { name: 'Bolgatanga', region: 'Upper East', coordinates: { lat: 10.7856, lng: -0.8513 }, population: '66K', popular: false },
      { name: 'Tema', region: 'Greater Accra', coordinates: { lat: 5.6833, lng: -0.0167 }, population: '161K', popular: false },
      { name: 'Tarkwa', region: 'Western', coordinates: { lat: 5.3000, lng: -1.9833 }, population: '35K', popular: false },
      { name: 'Konongo', region: 'Ashanti', coordinates: { lat: 6.6167, lng: -1.2167 }, population: '41K', popular: false },
      { name: 'Obuasi', region: 'Ashanti', coordinates: { lat: 6.2000, lng: -1.6833 }, population: '168K', popular: false },
      { name: 'Techiman', region: 'Bono East', coordinates: { lat: 7.5833, lng: -1.9333 }, population: '79K', popular: false },
      { name: 'Kumawu', region: 'Ashanti', coordinates: { lat: 6.8500, lng: -1.4000 }, population: '28K', popular: false },
      { name: 'Ejisu', region: 'Ashanti', coordinates: { lat: 6.7167, lng: -1.3500 }, population: '32K', popular: false },
      { name: 'Mampong', region: 'Ashanti', coordinates: { lat: 7.0667, lng: -1.4000 }, population: '42K', popular: false },
      { name: 'Bekwai', region: 'Ashanti', coordinates: { lat: 6.4500, lng: -1.5833 }, population: '56K', popular: false },
      { name: 'Nkawkaw', region: 'Eastern', coordinates: { lat: 6.5500, lng: -0.7667 }, population: '61K', popular: false }
    ]
  },
  nigeria: {
    name: 'Nigeria',
    flag: '🇳🇬',
    states: [
      {
        name: 'Lagos',
        cities: [
          { name: 'Lagos Island', coordinates: { lat: 6.5244, lng: 3.3792 }, population: '2.5M', popular: true },
          { name: 'Victoria Island', coordinates: { lat: 6.4281, lng: 3.4219 }, population: '1.2M', popular: true },
          { name: 'Ikeja', coordinates: { lat: 6.6018, lng: 3.3515 }, population: '800K', popular: true },
          { name: 'Surulere', coordinates: { lat: 6.5000, lng: 3.3500 }, population: '500K', popular: false },
          { name: 'Yaba', coordinates: { lat: 6.5167, lng: 3.3833 }, population: '300K', popular: false },
          { name: 'Oshodi', coordinates: { lat: 6.5500, lng: 3.3333 }, population: '400K', popular: false },
          { name: 'Alimosho', coordinates: { lat: 6.6167, lng: 3.2833 }, population: '1.2M', popular: false },
          { name: 'Ikorodu', coordinates: { lat: 6.6167, lng: 3.5000 }, population: '600K', popular: false },
          { name: 'Lekki', coordinates: { lat: 6.4500, lng: 3.5667 }, population: '400K', popular: true },
          { name: 'Ajah', coordinates: { lat: 6.4500, lng: 3.6167 }, population: '300K', popular: false }
        ]
      },
      {
        name: 'Rivers',
        cities: [
          { name: 'Port Harcourt', coordinates: { lat: 4.8156, lng: 7.0498 }, population: '1.2M', popular: true },
          { name: 'Obio-Akpor', coordinates: { lat: 4.8500, lng: 7.0000 }, population: '600K', popular: false },
          { name: 'Okrika', coordinates: { lat: 4.7333, lng: 7.0833 }, population: '200K', popular: false },
          { name: 'Eleme', coordinates: { lat: 4.7000, lng: 7.1167 }, population: '150K', popular: false },
          { name: 'Bonny', coordinates: { lat: 4.4333, lng: 7.1667 }, population: '180K', popular: false }
        ]
      },
      {
        name: 'Kano',
        cities: [
          { name: 'Kano', coordinates: { lat: 11.9914, lng: 8.5317 }, population: '4.1M', popular: true },
          { name: 'Ungogo', coordinates: { lat: 11.9667, lng: 8.6000 }, population: '800K', popular: false },
          { name: 'Fagge', coordinates: { lat: 11.9833, lng: 8.5333 }, population: '600K', popular: false },
          { name: 'Dala', coordinates: { lat: 11.9833, lng: 8.5167 }, population: '500K', popular: false },
          { name: 'Tarauni', coordinates: { lat: 11.9500, lng: 8.5500 }, population: '400K', popular: false }
        ]
      },
      {
        name: 'Kaduna',
        cities: [
          { name: 'Kaduna', coordinates: { lat: 10.5222, lng: 7.4384 }, population: '1.6M', popular: true },
          { name: 'Zaria', coordinates: { lat: 11.1111, lng: 7.7222 }, population: '600K', popular: false },
          { name: 'Kafanchan', coordinates: { lat: 9.5833, lng: 8.3000 }, population: '200K', popular: false },
          { name: 'Kachia', coordinates: { lat: 9.9833, lng: 7.9500 }, population: '150K', popular: false }
        ]
      },
      {
        name: 'Ondo',
        cities: [
          { name: 'Akure', coordinates: { lat: 7.2500, lng: 5.2000 }, population: '500K', popular: true },
          { name: 'Ondo', coordinates: { lat: 7.1000, lng: 4.8333 }, population: '300K', popular: false },
          { name: 'Owo', coordinates: { lat: 7.2000, lng: 5.5833 }, population: '250K', popular: false },
          { name: 'Ikare', coordinates: { lat: 7.5167, lng: 5.7500 }, population: '200K', popular: false }
        ]
      },
      {
        name: 'Oyo',
        cities: [
          { name: 'Ibadan', coordinates: { lat: 7.3964, lng: 3.8967 }, population: '3.6M', popular: true },
          { name: 'Oyo', coordinates: { lat: 7.8500, lng: 3.9333 }, population: '400K', popular: false },
          { name: 'Ogbomoso', coordinates: { lat: 8.1333, lng: 4.2500 }, population: '800K', popular: false },
          { name: 'Iseyin', coordinates: { lat: 7.9667, lng: 3.6000 }, population: '300K', popular: false },
          { name: 'Saki', coordinates: { lat: 8.6667, lng: 3.3833 }, population: '250K', popular: false }
        ]
      },
      {
        name: 'Imo',
        cities: [
          { name: 'Owerri', coordinates: { lat: 5.4833, lng: 7.0333 }, population: '600K', popular: true },
          { name: 'Okigwe', coordinates: { lat: 5.8167, lng: 7.3500 }, population: '200K', popular: false },
          { name: 'Orlu', coordinates: { lat: 5.7833, lng: 7.0333 }, population: '250K', popular: false },
          { name: 'Mbaise', coordinates: { lat: 5.4000, lng: 7.1000 }, population: '300K', popular: false }
        ]
      },
      {
        name: 'Enugu',
        cities: [
          { name: 'Enugu', coordinates: { lat: 6.4500, lng: 7.5000 }, population: '800K', popular: true },
          { name: 'Nsukka', coordinates: { lat: 6.8667, lng: 7.3833 }, population: '400K', popular: false },
          { name: 'Awka', coordinates: { lat: 6.2000, lng: 7.0667 }, population: '300K', popular: false },
          { name: 'Abakaliki', coordinates: { lat: 6.3167, lng: 8.1000 }, population: '250K', popular: false }
        ]
      },
      {
        name: 'Anambra',
        cities: [
          { name: 'Awka', coordinates: { lat: 6.2000, lng: 7.0667 }, population: '300K', popular: true },
          { name: 'Onitsha', coordinates: { lat: 6.1667, lng: 6.7833 }, population: '1.1M', popular: true },
          { name: 'Nnewi', coordinates: { lat: 6.0167, lng: 6.9167 }, population: '400K', popular: false },
          { name: 'Ekwulobia', coordinates: { lat: 6.1500, lng: 7.0167 }, population: '200K', popular: false }
        ]
      },
      {
        name: 'Delta',
        cities: [
          { name: 'Asaba', coordinates: { lat: 6.1833, lng: 6.7500 }, population: '400K', popular: true },
          { name: 'Warri', coordinates: { lat: 5.5167, lng: 5.7500 }, population: '800K', popular: true },
          { name: 'Sapele', coordinates: { lat: 5.9000, lng: 5.6833 }, population: '300K', popular: false },
          { name: 'Ughelli', coordinates: { lat: 5.5000, lng: 6.0000 }, population: '250K', popular: false }
        ]
      },
      {
        name: 'Edo',
        cities: [
          { name: 'Benin City', coordinates: { lat: 6.3176, lng: 5.6145 }, population: '1.2M', popular: true },
          { name: 'Auchi', coordinates: { lat: 7.0667, lng: 6.2667 }, population: '300K', popular: false },
          { name: 'Ekpoma', coordinates: { lat: 6.7500, lng: 6.1333 }, population: '200K', popular: false },
          { name: 'Uromi', coordinates: { lat: 6.7000, lng: 6.3333 }, population: '150K', popular: false }
        ]
      },
      {
        name: 'Abuja (FCT)',
        cities: [
          { name: 'Abuja', coordinates: { lat: 9.0820, lng: 7.3981 }, population: '3.3M', popular: true },
          { name: 'Gwagwalada', coordinates: { lat: 8.9500, lng: 7.0833 }, population: '200K', popular: false },
          { name: 'Kuje', coordinates: { lat: 8.8833, lng: 7.2333 }, population: '150K', popular: false },
          { name: 'Abaji', coordinates: { lat: 8.9667, lng: 6.9500 }, population: '100K', popular: false }
        ]
      }
    ]
  }
};

// Enhanced helper functions
export const getAllCities = () => {
  const cities = [];
  
  // Add Ghana cities
  LOCATIONS.ghana.cities.forEach(city => {
    cities.push({
      name: city.name,
      country: 'Ghana',
      region: city.region,
      coordinates: city.coordinates,
      population: city.population,
      popular: city.popular
    });
  });
  
  // Add Nigeria cities
  LOCATIONS.nigeria.states.forEach(state => {
    state.cities.forEach(city => {
      cities.push({
        name: city.name,
        country: 'Nigeria',
        state: state.name,
        coordinates: city.coordinates,
        population: city.population,
        popular: city.popular
      });
    });
  });
  
  return cities;
};

export const getCitiesByCountry = (country) => {
  if (country === 'ghana') {
    return LOCATIONS.ghana.cities.map(city => ({
      name: city.name,
      country: 'Ghana',
      region: city.region,
      coordinates: city.coordinates,
      population: city.population,
      popular: city.popular
    }));
  } else if (country === 'nigeria') {
    const cities = [];
    LOCATIONS.nigeria.states.forEach(state => {
      state.cities.forEach(city => {
        cities.push({
          name: city.name,
          country: 'Nigeria',
          state: state.name,
          coordinates: city.coordinates,
          population: city.population,
          popular: city.popular
        });
      });
    });
    return cities;
  }
  return [];
};

export const getPopularCities = () => {
  return getAllCities().filter(city => city.popular);
};

// Detailed Ghana locations with districts (for ProfileFeed)
export const GHANA_DETAILED_LOCATIONS = {
  'Greater Accra': [
    { name: 'Adjei-Kojo, Tema West', lat: 5.6750, lng: -0.0100, district: 'Tema West' },
    { name: 'Tema', lat: 5.6698, lng: -0.0166, district: 'Tema Metro' },
    { name: 'Tema New Town', lat: 5.6550, lng: -0.0050, district: 'Tema Metro' },
    { name: 'Community 1, Tema', lat: 5.6600, lng: -0.0200, district: 'Tema Metro' },
    { name: 'Community 25, Tema', lat: 5.6850, lng: 0.0100, district: 'Tema Metro' },
    { name: 'Sakumono', lat: 5.6250, lng: -0.0350, district: 'Tema Metro' },
    { name: 'Lashibi', lat: 5.6150, lng: -0.0400, district: 'Tema Metro' },
    { name: 'Spintex', lat: 5.6300, lng: -0.1000, district: 'Accra Metro' },
    { name: 'Baatsonaa', lat: 5.6200, lng: -0.0800, district: 'Accra Metro' },
    { name: 'Nungua', lat: 5.5933, lng: -0.0653, district: 'Accra Metro' },
    { name: 'Teshie', lat: 5.5850, lng: -0.1000, district: 'Accra Metro' },
    { name: 'La', lat: 5.5611, lng: -0.1489, district: 'Accra Metro' },
    { name: 'Osu', lat: 5.5550, lng: -0.1800, district: 'Accra Metro' },
    { name: 'Labadi', lat: 5.5583, lng: -0.1467, district: 'Accra Metro' },
    { name: 'Labone', lat: 5.5700, lng: -0.1700, district: 'Accra Metro' },
    { name: 'Airport Residential', lat: 5.6050, lng: -0.1700, district: 'Accra Metro' },
    { name: 'East Legon', lat: 5.6400, lng: -0.1500, district: 'Accra Metro' },
    { name: 'Madina', lat: 5.6833, lng: -0.1644, district: 'La Nkwantanang' },
    { name: 'Adenta', lat: 5.7200, lng: -0.1550, district: 'Adenta' },
    { name: 'Dome', lat: 5.6500, lng: -0.2300, district: 'Ga East' },
    { name: 'Achimota', lat: 5.6100, lng: -0.2300, district: 'Ga East' },
    { name: 'Dzorwulu', lat: 5.5950, lng: -0.2000, district: 'Accra Metro' },
    { name: 'Cantonments', lat: 5.5700, lng: -0.1850, district: 'Accra Metro' },
    { name: 'Ridge', lat: 5.5650, lng: -0.2000, district: 'Accra Metro' },
    { name: 'Accra Central', lat: 5.5560, lng: -0.2010, district: 'Accra Metro' },
    { name: 'Circle', lat: 5.5700, lng: -0.2200, district: 'Accra Metro' },
    { name: 'Darkuman', lat: 5.5700, lng: -0.2450, district: 'Accra Metro' },
    { name: 'Dansoman', lat: 5.5325, lng: -0.2622, district: 'Accra Metro' },
    { name: 'Mamprobi', lat: 5.5350, lng: -0.2300, district: 'Accra Metro' },
    { name: 'Korle Bu', lat: 5.5350, lng: -0.2250, district: 'Accra Metro' },
    { name: 'Kaneshie', lat: 5.5650, lng: -0.2450, district: 'Accra Metro' },
    { name: 'Tesano', lat: 5.5800, lng: -0.2400, district: 'Accra Metro' },
    { name: 'Abeka', lat: 5.5900, lng: -0.2350, district: 'Accra Metro' },
    { name: 'Lapaz', lat: 5.5950, lng: -0.2600, district: 'Ga West' },
    { name: 'Kasoa', lat: 5.5333, lng: -0.4250, district: 'Ga South' },
    { name: 'Weija', lat: 5.5550, lng: -0.3500, district: 'Ga South' },
    { name: 'Gbawe', lat: 5.5700, lng: -0.3200, district: 'Ga South' },
    { name: 'Awoshie', lat: 5.5900, lng: -0.2850, district: 'Ga South' },
    { name: 'Ablekuma', lat: 5.5800, lng: -0.2700, district: 'Ablekuma' },
    { name: 'Ashaiman', lat: 5.6889, lng: -0.0306, district: 'Ashaiman' },
    { name: 'Prampram', lat: 5.7167, lng: 0.1167, district: 'Ningo-Prampram' },
    { name: 'Kpone', lat: 5.7000, lng: 0.0300, district: 'Kpone-Katamanso' },
  ],
  'Ashanti': [
    { name: 'Kumasi', lat: 6.6885, lng: -1.6244, district: 'Kumasi Metro' },
    { name: 'Adum', lat: 6.6900, lng: -1.6250, district: 'Kumasi Metro' },
    { name: 'Oforikrom', lat: 6.6800, lng: -1.5650, district: 'Oforikrom' },
    { name: 'Asokwa', lat: 6.6600, lng: -1.5800, district: 'Asokwa' },
    { name: 'Tafo', lat: 6.7100, lng: -1.5850, district: 'Old Tafo' },
    { name: 'Suame', lat: 6.7200, lng: -1.6200, district: 'Suame' },
    { name: 'Bantama', lat: 6.7000, lng: -1.6450, district: 'Bantama' },
    { name: 'Ejisu', lat: 6.7333, lng: -1.4500, district: 'Ejisu' },
    { name: 'Obuasi', lat: 6.2063, lng: -1.6603, district: 'Obuasi' },
  ],
  'Central': [
    { name: 'Cape Coast', lat: 5.1054, lng: -1.2466, district: 'Cape Coast Metro' },
    { name: 'Kasoa', lat: 5.5333, lng: -0.4250, district: 'Awutu Senya East' },
    { name: 'Winneba', lat: 5.3525, lng: -0.6228, district: 'Effutu' },
  ],
  'Western': [
    { name: 'Takoradi', lat: 4.8832, lng: -1.7554, district: 'Sekondi-Takoradi' },
    { name: 'Sekondi', lat: 4.9167, lng: -1.7167, district: 'Sekondi-Takoradi' },
    { name: 'Tarkwa', lat: 5.3000, lng: -1.9833, district: 'Tarkwa-Nsuaem' },
  ],
  'Eastern': [
    { name: 'Koforidua', lat: 6.0941, lng: -0.2593, district: 'New Juaben' },
    { name: 'Nsawam', lat: 5.8000, lng: -0.3500, district: 'Nsawam-Adoagyiri' },
    { name: 'Nkawkaw', lat: 6.5500, lng: -0.7667, district: 'Kwahu West' },
  ],
  'Volta': [
    { name: 'Ho', lat: 6.6000, lng: 0.4700, district: 'Ho Municipality' },
    { name: 'Hohoe', lat: 7.1500, lng: 0.4700, district: 'Hohoe Municipality' },
    { name: 'Aflao', lat: 6.1167, lng: 1.1833, district: 'Ketu South' },
  ],
  'Northern': [
    { name: 'Tamale', lat: 9.4034, lng: -0.8393, district: 'Tamale Metro' },
    { name: 'Yendi', lat: 9.4500, lng: -0.0167, district: 'Yendi Municipal' },
  ],
  'Upper East': [
    { name: 'Bolgatanga', lat: 10.7856, lng: -0.8514, district: 'Bolgatanga' },
    { name: 'Navrongo', lat: 10.8933, lng: -1.0950, district: 'Kassena Nankana' },
  ],
  'Upper West': [
    { name: 'Wa', lat: 10.0667, lng: -2.5000, district: 'Wa Municipal' },
  ],
};

// Flatten for search
export const ALL_GHANA_DETAILED_LOCATIONS = Object.entries(GHANA_DETAILED_LOCATIONS).flatMap(([region, towns]) =>
  towns.map(town => ({ ...town, region }))
);

export const getNearbyCities = (userCity, radiusKm = 50) => {
  const allCities = getAllCities();
  const userCityData = allCities.find(city => 
    city.name.toLowerCase() === userCity.toLowerCase()
  );
  
  if (!userCityData) return [];
  
  const nearby = allCities.filter(city => {
    if (city.name === userCityData.name) return false;
    
    const distance = calculateDistance(
      userCityData.coordinates.lat,
      userCityData.coordinates.lng,
      city.coordinates.lat,
      city.coordinates.lng
    );
    
    return distance <= radiusKm;
  });
  
  return nearby.sort((a, b) => {
    const distA = calculateDistance(
      userCityData.coordinates.lat,
      userCityData.coordinates.lng,
      a.coordinates.lat,
      a.coordinates.lng
    );
    const distB = calculateDistance(
      userCityData.coordinates.lat,
      userCityData.coordinates.lng,
      b.coordinates.lat,
      b.coordinates.lng
    );
    return distA - distB;
  });
};

// Enhanced distance calculation with more accuracy
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Earth's radius in kilometers
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return Math.round(R * c * 10) / 10; // Round to 1 decimal place
};

// Enhanced user location detection with better error handling
export const getUserLocation = () => {
  return new Promise(async (resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser'));
      return;
    }

    try {
      if (navigator.permissions?.query) {
        const permission = await navigator.permissions.query({ name: 'geolocation' });
        if (permission?.state === 'denied') {
          reject(new Error('Location permission denied. Please enable location services.'));
          return;
        }
      }
    } catch (_) {
      // Ignore permission API failures and continue with geolocation request.
    }
    
    const options = {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 300000 // 5 minutes
    };
    
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude, accuracy } = position.coords;
        
        // Find the nearest city
        const allCities = getAllCities();
        let nearestCity = null;
        let shortestDistance = Infinity;
        
        allCities.forEach(city => {
          const distance = calculateDistance(
            latitude,
            longitude,
            city.coordinates.lat,
            city.coordinates.lng
          );
          
          if (distance < shortestDistance) {
            shortestDistance = distance;
            nearestCity = city;
          }
        });
        
        resolve({
          coordinates: { lat: latitude, lng: longitude },
          accuracy: accuracy,
          nearestCity,
          distance: shortestDistance,
          timestamp: new Date().toISOString()
        });
      },
      (error) => {
        let errorMessage = 'Unknown error occurred';
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'Location permission denied. Please enable location services.';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Location information unavailable.';
            break;
          case error.TIMEOUT:
            errorMessage = 'Location request timed out.';
            break;
          default:
            errorMessage = 'Unknown error occurred';
            break;
        }
        reject(new Error(errorMessage));
      },
      options
    );
  });
};

// New function to get cities by population range
export const getCitiesByPopulation = (minPopulation, maxPopulation) => {
  const allCities = getAllCities();
  return allCities.filter(city => {
    const population = parseInt(city.population.replace(/[^\d]/g, ''));
    return population >= minPopulation && population <= maxPopulation;
  });
};

// New function to get cities by popularity
export const getCitiesByPopularity = (popular = true) => {
  return getAllCities().filter(city => city.popular === popular);
};

// New function to estimate travel time (rough calculation)
export const estimateTravelTime = (distance, transportMode = 'car') => {
  const speeds = {
    car: 60,      // km/h in city
    motorcycle: 40, // km/h in city
    public: 25,   // km/h public transport
    walking: 5    // km/h walking
  };
  
  const speed = speeds[transportMode] || speeds.car;
  const timeHours = distance / speed;
  const timeMinutes = Math.round(timeHours * 60);
  
  if (timeMinutes < 60) {
    return `${timeMinutes} min`;
  } else {
    const hours = Math.floor(timeMinutes / 60);
    const minutes = timeMinutes % 60;
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }
};
